import { StatisticsAction } from "./actions";
import { LOAD_STATISTICS_SUCCESS } from "./actionTypes";
import { Statistics } from "./models";

export function statistics(state: Statistics = {
    adminStatistics: {
        appointmentsToBookCount: 0,
        employeesToMatchCount: 0,
        incompletePastAppointmentsCount: 0,
        outstandingTriageCount: 0,
        reportsToWriteCount: 0,
        tasksToCompleteCount: 0,
        unassignedTasksCount: 0,
        caseConversationCount: 0,
        reportsToQACount: 0,
        lastUpdated: null
    },
    adminUserStatistics: {
        appointmentsTodayCount: 0,
        incompleteAppointmentsCount: 0,
        reportsToWriteCount: 0,
        tasksToCompleteCount: 0,
        caseConversationCount: 0,
        lastUpdated: null
    }
}, action: StatisticsAction) {
    switch (action.type) {
        case LOAD_STATISTICS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
